import createVueComponent from '../createVueComponent';

const ArrowBigDown = createVueComponent('ArrowBigDownIcon', [
  ['path', { d: 'M9 3h6v11h4l-7 7-7-7h4z' }],
]);

export default ArrowBigDown;
